import Immutable from 'immutable';
import {
  PLAN_LOAD,
  PLAN_LOAD_FAIL,
  PLAN_LOAD_SUCCESS,
} from './actions';

const initialState = Immutable.fromJS({
  planData: {
    "planClassDetails": {},
    "marketablePlans": [
      "free",
      "pro",
      "premium",
      "enterprise"
    ],
    "currentPlanClass": "free"
  },
  loading: false,
  errorMessage: null
});

// Reducers
export default function planReducer(state = initialState, action) {
  switch (action.type) {
    case PLAN_LOAD:
      return state
        .set('loading', true)

    case PLAN_LOAD_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.errorMessage);

    case PLAN_LOAD_SUCCESS:
      return state
        .set('loading', false)
        .set('planData', action.planData);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/containers/Billing/reducer.js